<template>
    <div>
        <image-text-info
                :contentInfo="contentInfo"
                v-if="classify === 1"
                :currentLabelColor="currentLabelColor"></image-text-info>
        <video-info
                :contentInfo="contentInfo"
                v-if="classify === 2"
                :currentLabelColor="currentLabelColor"></video-info>
    </div>
</template>
<script>
    import imageTextInfo from './components/imageTextInfo'
    import videoInfo from './components/videoInfo'
export default{
    data() {
        return {
            contentInfo: '', //文章内容
            classify: '', //文章类型 1是文章, 2是视频
            contentId: '',
            randomColorList: [
                {color: '#3576E0', bg: '#D6EDFF'},
                {color: '#FF9F07', bg: '#FFF3CB'},
                {color: '#09af89', bg: '#c8f2e3'},
                {color: '#ff5f5f', bg: '#ffe3e5'},
            ],
            currentLabelColor: {}
        }
    },
    components: {
        imageTextInfo,
        videoInfo
    },
    created () {
        this.contentId = this.$route.query.id;
        //获取文章详情
        this.getContentInfo();
        let randomNum = this.random(0,3);
        this.currentLabelColor= this.randomColorList[randomNum];
    },
    methods: {
        getContentInfo() {
            this.$api.ARTICLES.getContent({
                id: this.contentId
            }).then(res => {
                let content = res.data;
                if(content.id) {
                    this.contentInfo = content;
                    this.classify = content.classify;
                }
            }).catch(err => {
                console.log("err", err);
            })
        },
        random(lower, upper) {
            return Math.floor(Math.random() * (upper - lower+1)) + lower;
        }
    }
}
</script>
<style lang="less" scoped>
    .content-manage-info{
        box-sizing: border-box;
        border-top: 1px solid #F0F0F0;
        display: flex;
        flex-direction: column;
        padding: 30px;
        .content-title{
            color: #333333;
            font-size: 32px;
            margin-bottom: 20px;
        }
        .base-info{
            display: flex;
            justify-content: space-between;
            font-size: 20px;
            margin-bottom: 30px;
            .author{
                color: #3576E0;
            }
            .time{
                color: #999999;
            }
        }
        .article-content{
            color: #333333;
            font-size: 26px;
            margin-bottom: 36px;
            /deep/ p{
                line-height: normal;
                margin-bottom: 20px;
                img{
                    max-width: 100%;
                }
            }
        }
        .other-info{
            display: flex;
            justify-content: space-between;
            font-size: 20px;
            margin-bottom: 25px;
            .source{
                color: #3576E0;
            }
            .label{
                padding: 5px 8px;
                color: #FF9F07;
                background-color: #FFF3CB;
                border-radius: 4px;
            }
        }
        .attachment-list{
            .attachment-item{
                font-size: 24px;
                margin-bottom: 10px;
                img{
                    width: 30px;
                    height: 30px;
                    margin-right: 8px;
                }
                a{
                    color: #3576E0;
                }
            }
        }
    }
</style>